module.exports = __webpack_public_path__ + "static/img/Man Peekaboo.de13895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Man Peekaboo.jpg
// module id = tC4i
// module chunks = 1